import React, { useContext, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DatetimePickerMenu from 'components/lib/datetime_picker_menu';
import { getDatetimeFromTimestamp, getTimestampFromDatetime } from 'components/lib/date/datetime_helpers';
import UpdateComposition from 'actions/composer/update_composition';
import { useExecuteAction } from 'components/hooks/connect_hooks';
import ComposerContext from 'components/composer/contexts/composer_context';

const StyledDatePickerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledDatePickerDue = styled.div`
  align-items: center;
  color: var(--color-gray-light);
  display: flex;
  font-size: var(--font-size-reduced);
  padding-right: 10px;
  line-height: 12px;
`;

const StyledDatePicker = styled.div`
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-grow: 1;
`;

export default function DatePicker() {
  const { t } = useTranslation();
  const { composition } = useContext(ComposerContext);
  const executeAction = useExecuteAction();
  const compositionId = composition.id;
  const [timestamp, setTimestamp] = useState(getDatetimeFromTimestamp(composition.content.dueAt));
  const onChangeDatetime = useCallback(
    attrs => {
      if (attrs.date) {
        let ts = getTimestampFromDatetime(attrs);
        setTimestamp(attrs);
        executeAction(UpdateComposition, {
          compositionId,
          attrs: {
            dueAt: ts,
          },
        });
      }
    },
    [compositionId, executeAction]
  );
  return (
    <StyledDatePickerContainer>
      <StyledDatePickerDue>{t('Due')}</StyledDatePickerDue>
      <StyledDatePicker>
        <DatetimePickerMenu
          className="taskCompositionForm-timePickerMenu"
          onChange={onChangeDatetime}
          placeholderText={t('Due date')}
          value={timestamp}
        />
      </StyledDatePicker>
    </StyledDatePickerContainer>
  );
}
